import { Button, Grid, HStack, Heading, Progress, useMediaQuery } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { authStore } from "../store/AuthStore";
import { format } from "date-fns";
import { theme } from "../chakra-theme";
import { CheckCircleIcon, LockIcon } from "@chakra-ui/icons";
import bgImage from '../assets/banner.png';
import { LanguageToggle } from "./LanguageToggle";
import { useLanguage } from "../lib/LanguageContext";

const tier_base = 'default';

export const TierTracker: React.FC = observer(() => {
  const user = authStore.user;
  useEffect(() => {
    if (!user) {
      const u = authStore.getUser();
      if (u) authStore.reFetchUser(u?.id)
    }
  }, [ user ]);
  const currentTierStructure = user?.tiers.find((t) => t.structure.id === tier_base)
  let val = currentTierStructure?.next ? 0 : 100
  if (currentTierStructure?.next && user) {
    const nextTotal = user.score + currentTierStructure?.next.points;
    const pointsUntilNext = currentTierStructure?.next.points;
    const percentage = (pointsUntilNext / nextTotal) * 100;
    val = Math.abs(percentage - 100);
  }
  const nextTier = currentTierStructure?.next ? currentTierStructure.next : {
    id: currentTierStructure?.id + '2',
    name: currentTierStructure?.name,
    points: currentTierStructure?.threshold || 0,
  }
  const isMaxTier = !currentTierStructure?.next;
  const [isDesktop] = useMediaQuery('(min-width: 800px)');
  const [isMobile] = useMediaQuery('(max-width: 430px)');
  const { translate } = useLanguage();

  return (
    <Grid
      position="relative"
      placeContent="center"
      backgroundPosition="center"
      backgroundImage={bgImage}
    >
      <LanguageToggle position="absolute" top={4} right={isMobile ? 'initial' : 8} left={isMobile ? 4 : 'initial'} />
      <Grid 
        gap="1em"
        color="white"
        alignItems="center"
        justifyItems="center"
        padding="3em 0 3em 0"
        templateRows="2em 1em 3em auto auto"
      >
        <Heading letterSpacing="-1px" size={ isDesktop ? '2xl' :"lg"}>{translate('WELCOME BACK')}, {user?.first_name.toUpperCase()}!</Heading>
        <Heading letterSpacing="-1px" size={ isDesktop ? 'xl' : "xs"}>{translate('Part of the Community since')} <span style={{color: theme.colors.brand[950]}}>{user?.optin_at  && translate(format(user.optin_at * 1000, 'LLLL'))} {user?.optin_at && format(user.optin_at * 1000, 'y')}</span></Heading>
        <Grid w="100%"  templateColumns="1fr 1fr">
          <HStack>
            <CheckCircleIcon />
            <Grid>
              <Heading letterSpacing="-1px" size="sn">{currentTierStructure?.name.toUpperCase()}</Heading>
              <Heading letterSpacing="-1px" size="xs" color="white">{translate('Unlocked')}!</Heading>
            </Grid>
          </HStack>
          <HStack placeSelf="center end">
            <Grid>
              <Heading letterSpacing="-1px" textAlign="end" size="sm">{nextTier?.name?.toUpperCase()}</Heading>
              <Heading letterSpacing="-1px" size="xs" color="white">{isMaxTier ? `${translate('Unlocked')}!` : `${nextTier.points} ${translate('Points to Unlock')}`}</Heading>
            </Grid>
            {isMaxTier ? <CheckCircleIcon /> : <LockIcon />}
          </HStack>
        </Grid>
        <Grid w="100%">
          <Progress colorScheme="brand2" rounded=".5em" h={isDesktop ? '1.5em' :  undefined} value={val} />
        </Grid>
        <Button backgroundColor="brand.950" fontSize={isDesktop ? 'large' : undefined} variant="solidSecondary" onClick={() => document.location.pathname = '/activity-history'}>{translate('View My Activity History')}</Button>
      </Grid>
    </Grid>
  )
});